<!--
2022-08-06 HHY 将this.takeNum从15改为10000以不让veiw more 按钮显示
2022-10-05 HHY 将less全局变量@height从70%变为60%
-->
<template>
  <div class="sharePage">
<!--    <div class="loading">-->
<!--      <div><img :src="loading"/></div>-->
<!--    </div>-->
  </div>
</template>

<script>
import loading from '@/assets/images/common/loading.gif'
export default {
  name: 'Share',
  data () {
    return {
      loading,
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
    }
  },
  components: {
  },
  mounted () {
    let shareCode = this.$route.query.s
    localStorage.setItem('shareCode', shareCode)
    if (window.location.href.indexOf('f=n') > -1) {
      localStorage.setItem('shareType', 'verjaardag')
    }
    this.$router.push('/Home')
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.sharePage {
  height: 100%;
  background-color: #000;

  .loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    text-align: center;

    > div {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 200px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Share/index.vue